const ALIAS = '/api';

export function getStopList() {
    return axios.get(`${ALIAS}/getStopList`);
}
